import React from 'react';
import {observer} from 'mobx-react';
import {IAddress} from '../../i';
import {isNullOrWhiteSpace} from '../../../util';

// Address lines of a completed redesign step card (Shipping, Billing address).

const regionNames = typeof Intl !== 'undefined' && 'DisplayNames' in Intl ? new Intl.DisplayNames(['en'], {type: 'region'}) : undefined;

export const getCountryName = (code: string): string => {
    try {
        return regionNames?.of(code) ?? code;
    } catch {
        return code;
    }
};

/** Name, company (when entered), street, "City ST 12345", country name. Empty parts are left out. */
export function addressSummaryLines(addr: IAddress): string[] {
    const street = [addr.address1.value, addr.address2.value, addr.address3.value, addr.address4.value].filter(x => !isNullOrWhiteSpace(x)).join(' ');
    const rawState = addr.state.value ?? '';
    const state = rawState.startsWith('AE') ? 'AE' : rawState;
    const cityLine = [addr.city.value, state, addr.postalCode.value].filter(x => !isNullOrWhiteSpace(x)).join(' ');

    const lines = [`${addr.firstName.value} ${addr.lastName.value}`];
    if (!isNullOrWhiteSpace(addr.companyName.value)) {
        lines.push(addr.companyName.value);
    }
    lines.push(street, cityLine, getCountryName(addr.country.value));
    return lines;
}

export const AbAddressLines = observer(({addr}: {addr: IAddress}) => (
    <>
        {addressSummaryLines(addr).map((line, i) => (
            <div key={i}>{line}</div>
        ))}
    </>
));

export const AbAddressSummary = observer(({addr}: {addr: IAddress}) => (
    <div className="ab-step-summary">
        <AbAddressLines addr={addr} />
    </div>
));
